import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { TreoAnimations } from 'tsui/@treo';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { AccountService } from 'app/core';
import { User, UserAssociation, Invitation } from 'app/core/models/user.types';
import { SheetTemplatesService } from 'app/modules/settings/sheet-templates/sheet-templates.service';
import { ProjectSheetsService } from 'app/modules/projects/details/sheets/sheets.service';
import { ProjectSheet } from 'app/modules/projects/details/sheets/sheets.types';
import { SheetTemplate } from 'app/modules/settings/sheet-templates/sheet-templates.types';

@Component({
  selector: 'project-sheets-add-project-sheet',
  templateUrl: './add-project-sheet.component.html',
  styleUrls: ['./add-project-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AddProjectSheetComponent implements OnInit {
  sheetTemplates: SheetTemplate[];
  addProjectSheetForm: UntypedFormGroup;
  accept: string[] = ['.xlsx, .csv, xlsx'];

  private _unsubscribeAll: Subject<void>;

  /**
   * Constructor
   *
   * @param {MatDialogRef} matDialogRef
   * @param {FormBuilder} _formBuilder
   */
  constructor(
    public matDialogRef: MatDialogRef<AddProjectSheetComponent>,
    private _accountService: AccountService,
    private _sheetTemplatesService: SheetTemplatesService,
    private _projectSheetsService: ProjectSheetsService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _formBuilder: UntypedFormBuilder,
  ) {
    this._unsubscribeAll = new Subject();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Create the form
    this.addProjectSheetForm = this._formBuilder.group({
      name: ['', [Validators.required]],
      sheet_template_id: ['', [Validators.required]],
    });

    this._sheetTemplatesService.sheetTemplates$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((sheetTemplates: SheetTemplate[]) => {
        if (sheetTemplates) {
          this.sheetTemplates = sheetTemplates;
        }
      });
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  onFileChanged(event) {
    let file = event.target.files[0];
  }

  /**
   * Save and close
   */
  saveAndClose(): void {
    this.addProjectSheetForm.disable();

    let projectSheet = this.addProjectSheetForm.value;

    //project.pipeline_id = this._projectsService.pipelineId;
    this._projectSheetsService.createProjectSheet(projectSheet).subscribe((projectSheet) => {
      this.discard();
    });
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Save the message as a draft
   */
  saveAsDraft(): void {}

  /**
   * Send the message
   */
  send(): void {}
}
